import React from 'react';

import {SequenceSchemaType} from 'constants/RegistryConstants';
import GenericNameTemplateField from 'name-templates/GenericNameTemplateField';
import {NameTemplatePart, NameTemplateType} from 'name-templates/NameTemplateConstants';
import SetNameTemplateModal, {SET_NAME_TEMPLATE_MODAL_KEY} from 'name-templates/SetNameTemplateModal';
import {ClientSchemaField} from 'registry/field/FieldTable';
import {SchemaField} from 'schemas/fields/SchemaFieldConstants';
import * as ModalContainer from 'ui-library/ModalContainer';
import {SettingsPopover} from 'ui-library/SettingsField';

export interface ContainerNameTemplateFieldProps {
  bioentityType: string; // see `client/constants/ModelTypeConstants.ts`
  sequenceType: SequenceSchemaType | null; // relevant when bioentityType = SEQUENCE
  schemaFields: Array<SchemaField | ClientSchemaField>;
  schemaId: string;
  nameTemplateParts: Array<NameTemplatePart>;
  isWritable: boolean; // whether we allow changing the name template
  setNameTemplateParts: (parts: Array<NameTemplatePart>) => Promise<boolean>;
}

export default class ContainerNameTemplateField extends React.Component<ContainerNameTemplateFieldProps> {
  openSetNameTemplateModal = (): void => {
    ModalContainer.open(
      SET_NAME_TEMPLATE_MODAL_KEY,
      <SetNameTemplateModal
        bioentityType={this.props.bioentityType}
        schemaFields={this.props.schemaFields}
        sequenceType={this.props.sequenceType}
        schemaId={this.props.schemaId}
        initialNameTemplateParts={this.props.nameTemplateParts}
        nameTemplateType={NameTemplateType.CONTAINER}
        itemType={null}
        onRequestSubmit={async (submitArgs) => {
          const didSubmit = await this.props.setNameTemplateParts(submitArgs.nameTemplateParts);
          if (didSubmit) {
            this.closeSetNameTemplateModal();
          }
        }}
        onRequestClose={this.closeSetNameTemplateModal}
      />
    );
  };

  closeSetNameTemplateModal = (): void => {
    ModalContainer.close(SET_NAME_TEMPLATE_MODAL_KEY);
  };

  handleRemoveNameTemplate = (): void => {
    this.props.setNameTemplateParts([]);
  };

  override render(): JSX.Element {
    const helpIconContent = (
      <SettingsPopover
        title="Container name template"
        renderContent={() => (
          <div className="tagSchemaSettings-popover">
            <p>
              Automatically name containers when this entity is transferred into them as contents. This is a
              point-in-time naming that only happens when transferring that entity into a newly created or
              empty container.
            </p>
            <p>
              Existing containers will not have their names automatically updated if this name template or
              item metadata is changed.
            </p>
          </div>
        )}
      />
    );

    return (
      <GenericNameTemplateField
        {...this.props}
        label="Container name template"
        helpIconContent={helpIconContent}
        setNameTemplateParts={this.openSetNameTemplateModal}
        removeNameTemplateParts={this.handleRemoveNameTemplate}
        testAttrComponent="ContainerNameTemplateField"
      />
    );
  }
}
